import { PerformanceDatapoint } from 'owa-analytics';

export function logGroupSwitched(datapoint: PerformanceDatapoint): void {
    datapoint.addCustomProperty('Info', 'User switched group before action finished');
}

export function logGeneralErrorMessage(datapoint: PerformanceDatapoint, error: string): void {
    datapoint.addCustomProperty('Error', error);
}

export function getErrorFromObject(error: any): Error {
    return error instanceof Error ? error : new Error(JSON.stringify(error));
}
